import { render, staticRenderFns } from "./RetailList.vue?vue&type=template&id=ac6cde36&scoped=true"
import script from "./RetailList.vue?vue&type=script&lang=js"
export * from "./RetailList.vue?vue&type=script&lang=js"
import style0 from "./RetailList.vue?vue&type=style&index=0&id=ac6cde36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6cde36",
  null
  
)

export default component.exports